import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
// Local Deps
import errorMsgs from '../config/errors';
import materialFilters from '../config/searchFilters/materialFilters';
import methodFilters from '../config/searchFilters/methodFilters';

/*--------------------------------------
  AGGS FILTER DECORATOR
----------------------------------------*/
export function addAggCountsToFilters(filterConfig, buckets) {
  if (isEmpty(buckets)) return filterConfig;
  const filtersWithFacets = filterConfig.filters.map(fltr => {
    const matchingBucket = buckets.find(bkt => bkt.key === fltr.text);
    if (!matchingBucket) return fltr;
    return {
      ...fltr,
      count: matchingBucket.docCount,
    };
  });
  return {
    ...filterConfig,
    filters: filtersWithFacets,
  };
}

/*--------------------------------------
  CONFIGURE FILTER GROUPS
----------------------------------------*/
export function configureFilterGroups(
  onFilterClick,
  aggsObject = {
    methodBuckets: [],
    materialBuckets: [],
  },
) {
  const { methodBuckets, materialBuckets } = aggsObject;
  const methodFiltersWithAggs = addAggCountsToFilters(
    methodFilters,
    methodBuckets,
  );
  const materialFiltersWithAggs = addAggCountsToFilters(
    materialFilters,
    materialBuckets,
  );
  return [
    {
      ...materialFiltersWithAggs,
      onFilterClick,
    },
    {
      ...methodFiltersWithAggs,
      onFilterClick,
    },
  ];
}

/*--------------------------------------
  REMOVE FILTER FROM COMPLEX OBJECT
----------------------------------------*/
export function removeFilterFromComplexObject({
  complexObject,
  groupKey,
  filter,
  targetProperty = 'id',
}) {
  if (!groupKey) throw Error(errorMsgs.filterGroupUtils.missingGroupKey);
  const targetedValue = get(filter, targetProperty);
  if (!filter || !targetedValue)
    throw Error(errorMsgs.filterGroupUtils.missingFilter);
  const filteredGroup = complexObject[groupKey].filter(
    qp => qp !== targetedValue,
  );
  const newParams = {
    ...complexObject,
    [groupKey]: filteredGroup,
  };
  if (isEmpty(filteredGroup)) {
    delete newParams[groupKey];
  }
  return newParams;
}

/*--------------------------------------
  ADD FILTER TO COMPLEX OBJECT
----------------------------------------*/
export function addFilterToComplexObject({
  complexObject = {},
  groupKey,
  filter,
  targetProperty = 'id',
}) {
  const targetedValue = get(filter, targetProperty);
  if (!groupKey) throw Error(errorMsgs.filterGroupUtils.missingGroupKey);
  if (!filter || !targetedValue)
    throw Error(errorMsgs.filterGroupUtils.missingFilter);
  const groupToModify = get(complexObject, groupKey, []);
  const newParams = {
    ...complexObject,
    [groupKey]: [...groupToModify, targetedValue],
  };
  return newParams;
}

/* ----------------------------------
  REMOVE FILTER FROM PARAMS OBJECT
  ----------------------------------*/

export function removeFilterFromParamsObject({
  complexObject,
  groupKey,
  filter,
  targetProperty = 'value',
}) {
  if (!groupKey) throw Error(errorMsgs.filterGroupUtils.missingGroupKey);
  const targetedValue = get(filter, targetProperty);
  if (!filter || (!targetedValue && targetedValue !== 0))
    throw Error(errorMsgs.filterGroupUtils.missingFilter);

  const newParams = { ...complexObject };
  delete newParams[groupKey];

  return newParams;
}

/* ----------------------------------
  ADD FILTER TO PARAMS
  ----------------------------------*/
export function addFilterToParamsObject({
  complexObject = {},
  groupKey,
  filter,
  targetProperty = 'value',
}) {
  const targetedValue = get(filter, targetProperty);
  if (!groupKey) throw Error(errorMsgs.filterGroupUtils.missingGroupKey);
  if (!filter || (!targetedValue && targetedValue !== 0))
    throw Error(errorMsgs.filterGroupUtils.missingFilter);
  const newParams = {
    ...complexObject,
    [groupKey]: targetedValue,
  };
  return newParams;
}

/*--------------------------------------
  FORMAT FILTERS FOR API
----------------------------------------*/
export function formatFiltersForApi(rawFilters, filterList) {
  const formattedFilters = rawFilters.map(rawFilter => {
    const match = filterList.find(fltr => rawFilter === fltr.id);
    return match.text;
  });
  return formattedFilters;
}

/*--------------------------------------
  FORMAT FILTERS FOR UI
----------------------------------------*/
export function formatFiltersForUI(rawFilters, filterList) {
  const formattedFilters = rawFilters.map(rawFilter => {
    const match = filterList.find(
      fltr => rawFilter === fltr.text.toLowerCase(),
    );
    return match.id;
  });
  return formattedFilters;
}



// WEBPACK FOOTER //
// ./src/utils/filterGroupsUtils.js